import React from 'react';
import { Switch, Route } from 'react-router-dom';
import PropTypes from 'prop-types';
import Home from './Home';
import Login from './Login';
import LoginReceiver from './LoginReceiver';
import NoMatch from '../components/NoMatch';
import Logout from '../components/Logout';
import PrivateRoute from '../components/PrivateRoute';

const TYPE_CODE_MAP = {
  inv: 'invoice',
  invoice: 'invoice',
  wo: 'workOrder',
  workorder: 'workOrder',
  quote: 'quote',
  credit: 'invoice'
};

const parseDeepLink = (search) => {
  const params = new URLSearchParams(search);
  const type = TYPE_CODE_MAP[(params.get('type') || '').toLowerCase()];
  const rawId = (params.get('id') || '').trim();
  if (!type || !rawId) {
    return null;
  }
  const version = (params.get('version') || '').trim();
  return {
    type,
    documentNumber: rawId.replace(/^0+/, '').toUpperCase(),
    showDoc: params.get('showDoc') !== 'false',
    version: version || undefined
  };
};

const MainRouter = props => {
  const {
    isAdmin,
    isLoggedIn,
  } = props;

  return (
    <Switch>
      <Route exact path="/" render={rest => (<Login {...rest} isLoggedIn={isLoggedIn} />)}/>
      <Route path="/authorizing" render={rest => (<LoginReceiver {...rest}/>)}/>
      <PrivateRoute path="/home" component={Home} isAdmin={isAdmin} {...props}/>
      <PrivateRoute
        path="/document"
        component={Home}
        isAdmin={isAdmin}
        {...props}
        deepLink={parseDeepLink(props.location ? props.location.search : '')}
      />
      <Route path="/logout" render={rest => <Logout {...rest} />}/>
      <Route component={NoMatch} />
    </Switch>
  );
};
export default MainRouter;

MainRouter.propTypes = {
  isAdmin: PropTypes.bool.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
};
